export default "__VITE_ASSET__CwpKodZQ__"